import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserAuditListComponent } from "src/app/components/user-audit-list/user-audit-list/user-audit-list.component";

@Injectable()
export default class UserAuditCanDeactivateGuard
     {
    canDeactivate(component,_route: ActivatedRouteSnapshot, _state:           
        RouterStateSnapshot,nextState?: RouterStateSnapshot) {  
            let  selectedModel = localStorage.getItem("isAuditInProgress");
            if(selectedModel != undefined)
                return component.canDeactivate(nextState.url);
            else
                return true;            
    }
}


